// セッション関連
import commonClass from "./commonClass";

export default class blockDisableClass extends commonClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }
  // class変数定義
  _classValiableDefine() {
    // this._trgCls;
    // this._prtCls;
  }


  // 初期化用関数
  _init() {
    this._main();
  }

  // リサイズ用関数
  _resize() {
  }

  // メイン処理
  _main() {
    var cls = this;
  }

  _setSelector(trg, prt) {
    var cls = this;

    var trgCls = trg;
    var prtCls = prt;

    $(document).on('change', 'input[type="checkbox"]' + trgCls, function() {
      var $this = $(this);
      cls._tglDisable($this, prtCls);
      $this.closest('label').toggleClass('is-frm_disableTrg');;
      return false;
    });
  }

  _tglDisable($self, prtCls) {
    var cls = this;

    $self.closest(prtCls).toggleClass('is-frm_disableSec');
  }
}